export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";